import { render } from "./MessageStepReviewPage.vue?vue&type=template&id=2288b624"
import script from "./MessageStepReviewPage.vue?vue&type=script&lang=js"
export * from "./MessageStepReviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__